import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useApp } from "../context/AppContext";
import { api } from "../lib/api";
import { ProductCard } from "../components/ProductCard";
import { ArrowRight, ArrowLeft } from "lucide-react";

const HERO = "https://customer-assets.emergentagent.com/job_7f06c548-253d-46ff-97f6-8e1ce04a5d90/artifacts/4g1817v2_F0315E6D-0C5A-4490-AE4B-EEDDFA6C43C6.png";
const INTERIOR = "https://customer-assets.emergentagent.com/job_7f06c548-253d-46ff-97f6-8e1ce04a5d90/artifacts/c0yyfh0i_2158037C-C47C-4007-AC3E-FB88F9D340F9.png";

export default function Home() {
    const { t, lang } = useApp();
    const [products, setProducts] = useState([]);
    const Arrow = lang === "ar" ? ArrowLeft : ArrowRight;

    useEffect(() => {
        api.get("/products").then((r) => setProducts(r.data)).catch(() => {});
    }, []);

    return (
        <div data-testid="home-page">
            {/* HERO */}
            <section className="relative min-h-[100vh] overflow-hidden">
                <img src={HERO} alt="SRAA TENT" className="absolute inset-0 w-full h-full object-cover" />
                <div className="absolute inset-0 hero-overlay" />
                <div className="absolute inset-0 grain" />

                <div className="relative z-10 max-w-[1400px] mx-auto px-6 lg:px-10 pt-40 pb-24 min-h-[100vh] flex flex-col justify-end">
                    <div className="max-w-2xl fade-up">
                        <div className="overline mb-6">{t.hero.overline}</div>
                        <h1 className="section-heading text-5xl md:text-7xl lg:text-8xl text-white leading-[1.02] mb-6">
                            {t.hero.title}
                        </h1>
                        <p className="text-white/75 text-lg md:text-xl max-w-xl leading-relaxed mb-10">
                            {t.hero.subtitle}
                        </p>
                        <div className="flex flex-wrap gap-4">
                            <Link to="/products" data-testid="hero-cta-products" className="btn-gold btn-gold-filled">
                                {t.hero.cta_products} <Arrow size={16} />
                            </Link>
                            <Link to="/contact" data-testid="hero-cta-contact" className="btn-gold">
                                {t.hero.cta_contact}
                            </Link>
                        </div>
                    </div>
                </div>

                <div className="absolute bottom-0 inset-x-0 hairline-strong opacity-60" />
            </section>

            {/* FEATURED */}
            <section className="max-w-[1400px] mx-auto px-6 lg:px-10 py-24 lg:py-32">
                <div className="flex flex-col lg:flex-row justify-between items-start gap-6 mb-16">
                    <div>
                        <div className="overline mb-4">{t.sections.featured_overline}</div>
                        <h2 className="section-heading text-4xl md:text-5xl lg:text-6xl text-white max-w-2xl">
                            {t.sections.featured_title}
                        </h2>
                    </div>
                    <p className="text-white/60 max-w-md text-base leading-relaxed lg:pt-10">
                        {t.sections.featured_sub}
                    </p>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-10">
                    {products.slice(0, 6).map((p) => (
                        <ProductCard key={p.id} product={p} />
                    ))}
                </div>

                <div className="mt-16 flex justify-center">
                    <Link to="/products" data-testid="home-view-all-btn" className="btn-gold">
                        {lang === "ar" ? "عرض جميع المنتجات" : "View All Products"} <Arrow size={14} />
                    </Link>
                </div>
            </section>

            {/* STORY */}
            <section className="bg-[#0c0c0c] border-y border-[#D4AF37]/15">
                <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-24 lg:py-32 grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center">
                    <div className="order-2 lg:order-1">
                        <div className="overline mb-6">{t.sections.story_overline}</div>
                        <h2 className="section-heading text-4xl md:text-5xl text-white mb-8 leading-[1.1]">
                            {t.sections.story_title}
                        </h2>
                        <div className="hairline mb-8 w-24" />
                        <p className="text-white/70 text-lg leading-relaxed mb-10">
                            {t.sections.story_body}
                        </p>
                        <Link to="/contact" className="btn-gold">
                            {t.sections.cta_cta} <Arrow size={14} />
                        </Link>
                    </div>
                    <div className="order-1 lg:order-2 relative aspect-[4/5]">
                        <div className="absolute inset-0 border border-[#D4AF37]/30 translate-x-4 translate-y-4" />
                        <img src={INTERIOR} alt="Majlis interior" className="relative w-full h-full object-cover border border-[#D4AF37]/40" />
                    </div>
                </div>
            </section>
        </div>
    );
}
